import { TaskInternalType } from '@gcv/shared';

import { TaskRowType } from '../../tasks/tasks.model';

export const getTaskRowType = (internalType: TaskInternalType | undefined): TaskRowType => {
  if (internalType === TaskInternalType.QUESTIONNAIRE) return TaskRowType.Questionnaire;
  if (internalType === TaskInternalType.REVISE_QUESTIONNAIRE) return TaskRowType.QuestionnaireRevision;
  return TaskRowType.Task;
};
